const rootCommon = {
  display: "flex",
  flexDirection: "column",
  minHeight: "750px",
  paddingTop: "10px",
  paddingBottom: "20px",
  backgroundColor: 'white',
  justifyContent: "space-between",
  opacity: 1,
  TransitionEvent: "opacity 0.5s linear",
  border: "1px solid #F5F5F5"
}
const confirBoxCommon = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  
}
const styles = theme => ({
  root: {
    ...rootCommon,
    width: "680px",
    paddingLeft: "20px",
    paddingRight: "20px",

  },
  rootMobile: {
    ...rootCommon,
    width: "370px",
    paddingLeft: "8px",
    paddingRight: "10px",
    marginRight: "5px",
  },
  errMsg: {
    fontSize: 15,
    fontWeight: 500,
    color: '#ED1944',
    marginBottom: '15px',
    marginTop: '35px',
  },
  succMsg: {
    fontSize: 20,
    fontWeight: 700,
    color: '#000000',
    marginBottom: '15px',
    marginTop: '35px',
    textAlign: 'center'
  },
  succMsgNew: {
    fontSize: 24,
    fontWeight: 500,
    color: '#000000',
    marginBottom: '27px',
    marginTop: '27px',
    textAlign: 'center'
  },
  succMsgNewSubtitle: {
    fontSize: 17,
    fontWeight: 400,
    color: '#000000',
    marginBottom: '13px',
    textAlign: 'center'
  },
  successMsgBox: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    border: '1px solid #DEDEDE',
    borderRadius: '5px',
    padding: '10px'
  },
  succMsg2: {
    fontSize: 15,
    fontWeight: 400,
    color: '#000000',
    marginBottom: '21px',
  },
  succMsgTime: {
    fontSize: 15,
    fontWeight: 600,
    color: '#000000',
    marginBottom: '21px',
  },
  succMsg3: {
    fontSize: 15,
    fontWeight: 500,
    color: '#000000',
    marginBottom: '25px',
    textAlign: 'center'
  },
  addtoCalendarText: {
    fontSize: 15,
    fontWeight: 400,
    color: theme.palette.secondary.main,
    marginBottom: '25px',
    cursor: 'pointer',
  },
  verifyText: {
    fontSize: 14,
    fontWeight: 400,
    color: '#404040',
    cursor: 'pointer'
  },
  noteText: {
    fontSize: 13,
    fontWeight: 400,
    color: '#404040',
    marginTop: '8px',
    marginBottom: '8px'
  },
  outerBox: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    maxHeight: "90vh",
  },
  outerBoxEmbedd: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start'
  },
  titleFont: {
    fontSize: 24,
    fontWeight: 500,
    color: '#000000',
    marginBottom: '25px'
  },
  subTitleFont: {
    fontSize: 15,
    fontWeight: 500,
    color: '#000000',
    marginBottom: '15px'
  },
  radioBox: {
    height: "60px",
    width: "100%",
    border: '1px solid #DEDEDE',
    paddingLeft: '20px',
    display: "flex",
    alignItems: "center",
    backgroundColor: "white"
  },
  whiteBox: {
    backgroundColor: "white"
  },
  calendarBox: {
    height: "370px",
    display: 'flex',
    width: "100%",
    // border: '1px solid #DEDEDE',
    marginBottom: "25px",
    padding: "5px",
    backgroundColor: "white"
  },
  paymentBox: {
    display: "flex",
    width: "98%",
    height: "60px",
    justifyContent: "space-between",
    border: '1px solid #DEDEDE',
    backgroundColor: "white",
    marginLeft: '10px',
  },
  confirmBtn: {
    ...confirBoxCommon,
    width: "175px",
    width: "100%",
    cursor: 'pointer',
    backgroundColor: theme.palette.secondary.main
  },
  confirmBtnFull: {
    ...confirBoxCommon,
    height: "100%",
    width: "100%",
    cursor: 'pointer',
    backgroundColor: theme.palette.secondary.main
  },
  confirmBtnDisabled: {
    ...confirBoxCommon,
    width: "175px",
    width: "100%",
    opacity: 0.5,
    pointerEvents: 'none',
    backgroundColor: theme.palette.secondary.main
  },
  confirmBtnDisabledFull: {
    ...confirBoxCommon,
    height: "100%",
    width: "100%",
    opacity: 0.5,
    pointerEvents: 'none',
    backgroundColor: theme.palette.secondary.main
  },
  btnText: {
    fontSize: 18,
    fontWeight: 500,
    color: '#FFFFFF',
  },
  paymentText: {
    fontSize: 15,
    fontWeight: 400,
    color: '#000000',
    // marginTop: '5px'
  },
  modifyText: {
    fontSize: 15,
    fontWeight: 400,
    color: theme.palette.secondary.main,
    marginLeft: '8px'
  },
  paymentModes: {
    width: "100%",
    height: "100%",
    padding: '8px'
  },
  flexBox: {
    display: "flex",
    justifyContent: "space-between",
    width: '100%'
  },
  modifyBox: {
    display: "flex",
    cursor: 'pointer'
  },
  photographImage: {
    height: '10px',
    width: '132px'
  },
  widgetLauncherIcon: {
    height: '25px'
  },
  launcherBox: {
    cursor: 'pointer',
    marginTop: '20px'
  },
  pricingBox: {
    height: '50px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '500px',
    border: '1px solid #FA6401',
    cursor: 'pointer',
    paddingLeft: '30px',
    padding: '10px',
    marginTop: '20px'
  },
  priceText: {
    fontSize: '15',
    fontWeight: 500,
    color: '#000000'
  },
  pricingTickIcon: {
    height: '24px',
    width: '24px'
  },
  waitingBox: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '30px'
  },
  waitingIcon: {
    height: '48px',
    width: '48px'
  },
  avatar: {
    backgroundColor: "#0091FF",
    marginLeft: 10,
    marginRight: 10,
  },
  clientName: {
    color: '#323638',
    fontWeight: 'Medium',
    fontSize: 18
  },
  clientDesignationText: {
    color: '#000000',
    fontWeight: 400,
    fontSize: 12,
    marginTop: '5px'
  }
});

export default styles;